import React from 'react';
import { Modal } from 'react-bootstrap';
import { CancellationSummary } from 'guest-data-types-ts-lib';
import { CurrencyUtils, TranslationUtils } from '../../utils';
import { Button } from '../Button/Button';
import './ConfirmCancelModal.scss';

interface ConfirmCancelModalProps {
    isShowing: boolean;
    summary: CancellationSummary;
    onConfirm: (summary: CancellationSummary) => void;
    onDismiss: () => void;
}

export const ConfirmCancelModal: React.FC<ConfirmCancelModalProps> = (props) => {
    const { summary, isShowing, onConfirm, onDismiss } = props;

    return (
        <Modal id="confirm-cancel-modal" show={isShowing} onHide={onDismiss} backdropClassName={'custom-modal-backdrop.show'}>
            <Modal.Header closeButton />
            <div className="confirm-cancel-modal">
                <div className="confirm-cancel-modal-body">
                    <h5 className={'heading-large'}>{TranslationUtils.get('sure_you_want_to_cancel')}</h5>

                    {summary.cancellation_instructions && (
                        <>
                            <div className={'body-regular'} dangerouslySetInnerHTML={{ __html: summary.cancellation_instructions }} />
                        </>
                    )}

                    <div className="confirm-cancel-modal-buttons">
                        <Button block variant="default" label={TranslationUtils.get('no_dont_cancel')} onClick={onDismiss} />
                        <Button block variant="primary" label={TranslationUtils.get('yes_cancel_now')} onClick={() => onConfirm(summary)} />
                    </div>
                </div>
            </div>
        </Modal>
    );
};
